import { Separator } from '@radix-ui/react-dropdown-menu'

import { styled } from '~/styled'

export const DropdownMenuSeparator = styled(Separator, {
  base: ['h-px', 'bg-grey-600', 'my-2']
})
